import React, { createContext, useContext } from 'react';

export type AppType = 'app' | 'agent' | 'parent' | 'nativeAgent';

export interface CurrentApp {
    type: AppType;
    isParentApp: boolean;
    isAgentApp: boolean;
    isNativeAgentApp: boolean;
}

const CurrentAppContext = createContext<CurrentApp>({
    type: 'app',
    isParentApp: false,
    isAgentApp: false,
    isNativeAgentApp: false,
});

export function checkCurrentApp(): CurrentApp {
    if (typeof window === 'undefined' || !window.location.host) {
        return {
            type: 'app',
            isParentApp: false,
            isAgentApp: false,
            isNativeAgentApp: false
        };
    }

    if (window.location.host === process.env.PARENT_FRONTEND_DOMAIN) {
        return {
            type: 'parent',
            isParentApp: true,
            isAgentApp: false,
            isNativeAgentApp: false
        };
    }

    if (process.env.AGENT_FRONTEND_DOMAIN && window.location.host.startsWith(process.env.AGENT_FRONTEND_DOMAIN)) {
        if (window.AndroidBridge) {
            return {
                type: 'nativeAgent',
                isParentApp: false,
                isAgentApp: true,
                isNativeAgentApp: true
            };
        }

        return {
            type: 'agent',
            isParentApp: false,
            isAgentApp: true,
            isNativeAgentApp: false
        };
    }

    return {
        type: 'app',
        isParentApp: false,
        isAgentApp: false,
        isNativeAgentApp: false
    };
}

function useCurrentApp() {
    return useContext(CurrentAppContext);
}

function CurrentAppProvider({ children }: { children: React.ReactNode; }) {
    const currentApp = checkCurrentApp();

    return (
        <CurrentAppContext.Provider value={currentApp}>
            {children}
        </CurrentAppContext.Provider>
    );
}


export { CurrentAppProvider, useCurrentApp };
